import {
    FETCH_SUMMARY_REPORT_FAILURE,
    FETCH_SUMMARY_REPORT_REQUEST,
    FETCH_SUMMARY_REPORT_SUCCESS,
  } from '../actions/summaryReportActions';

  const initialState = {
    data: [],
    loading: false,
    error: null,
  };

  export const summaryReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SUMMARY_REPORT_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_SUMMARY_REPORT_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case FETCH_SUMMARY_REPORT_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
